/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Report_PrefixInputs */

const en_error_report_prefix = /** @type {(inputs: Error_Report_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the problem persists, please file a bug report`)
};

const pl_error_report_prefix = /** @type {(inputs: Error_Report_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli problem się powtarza, zgłoś błąd`)
};

/**
* | output |
* | --- |
* | "If the problem persists, please file a bug report" |
*
* @param {Error_Report_PrefixInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_report_prefix = /** @type {((inputs?: Error_Report_PrefixInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Report_PrefixInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_error_report_prefix(inputs)
	return en_error_report_prefix(inputs)
});